if (document.querySelector('.js-ism-tabs') !== null) {
    import(/* webpackChunkName: "ism-tabs" */ './ism-tabs');
}
if (document.querySelector('.js-load-more-sol') !== null) {
    import(/* webpackChunkName: "ism-load" */ './ism-load-more');
}
if (document.querySelector('.js-send-callback') !== null) {
    import(/* webpackChunkName: "track-form" */ './track-form');
}
export {};
